<template>
  <div>
    <a-form
        :form="form"
        :label-col="{ span: 9 }"
        :wrapper-col="{ span: 7 }"
        @submit="submit"
    >
      <h3 style="text-align: center">Dane osobowe</h3>
      <p style="text-align: center; max-width: 600px; margin: 12px auto">
        Wypełnij formularz swoimi danymi osobowymi. Nie pomyl pól imię z polem
        nazwisko! To bardzo ważne przy późniejszym dostępie do konta!
      </p>
      <a-form-item label="Imię">
        <a-input
            v-decorator="[
            'given-name',
            { rules: [{ required: true, message: 'Imię jest wymagane!' }] },
          ]"
            :maxLength="250"
        />
      </a-form-item>
      <a-form-item label="Nazwisko">
        <a-input
            v-decorator="[
            'family-name',
            { rules: [{ required: true, message: 'Nazwisko jest wymagane!' }] },
          ]"
            :maxLength="250"
        />
      </a-form-item>
      <a-form-item label="Numer PESEL/Paszport">
        <a-input
            v-decorator="[
            'pesel',
            {
              rules: [
                {
                  required: true,
                  message: 'Numer PESEL/Paszport jest wymagany!',
                },
                {
                  min: 5,
                  message: 'Wartość jest za krótka!',
                },
              ],
            },
          ]"
            :maxLength="20"
        />
      </a-form-item>
      <a-form-item label="Adres e-mail">
        <a-input
            v-decorator="[
            'email',
            {
              rules: [
                {
                  required: false,
                  message: 'Adres e-mail ma nieprawidłowy format.',
                  pattern:
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                },
              ],
            },
          ]"
            :maxLength="250"
        />
      </a-form-item>
      <a-form-item :wrapperCol="{ span: 7, offset: 9 }">
        <p style="padding-bottom: 0em; line-height: 1.5em">
          <strong
          >Adres e-mail jest polem opcjonalnym. Nie musisz go
            wypełniać!</strong
          >
        </p>
        <p style="line-height: 1.6em">
          <small style="opacity: 0.75"
          >Jeśli jednak zdecydujesz się na tę opcję to otrzymasz wiadomość z
            potwierdzeniem zaakceptowania wniosku oraz w przyszłości ułatwi Ci
            to proces logowania do panelu klienta. Adres ten nie zostanie użyty
            do wysyłania reklam i spamu.</small
          >
        </p>
      </a-form-item>
    </a-form>

    <a-row style="text-align: center">
      <!-- <a-button
        style="margin-right: 24px;"
        type="default"
        @click="back"
      >  <a-icon type="left" />
        Wróć
      </a-button> -->
      <a-button
          :disabled="!isVerificationCompleted"
          type="primary"
          @click="submit"
      >
        Dalej
        <a-icon type="right"/>
      </a-button>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this, {name: "coordinated"}),
    };
  },
  mounted() {
    let data = this.$store.getters["getPersonalData"];
    this.form.setFieldsValue({
      "given-name": data.name,
      "family-name": data.surname,
      pesel: data.personIdentificationNumber,
      email: data.emailAddress,
    });
  },
  methods: {
    submit: function () {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          var fixedDTO = {
            name: values["given-name"],
            surname: values["family-name"],
            personIdentificationNumber: values["pesel"],
            emailAddress: values["email"],
          };
          this.$store.commit("updatePersonalData", fixedDTO);

          this.$emit("nextStep");
        }
      });
    },
    back: function () {
      this.$emit("prevStep");
    },
  },
  computed: {
    isVerificationCompleted: function () {
      return true;
    },
  },
};
</script>
